import type { CityConfig } from "../city-template/types";

export const milesCityConfig: CityConfig = {
  city: "Miles City",
  state: "Montana",
  stateAbbr: "MT",
  slug: "miles-city",
  route: "/cities/miles-city",
  title: "Emergency Passport Miles City, MT — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Miles City, MT — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Miles City, Custer County, Glendive, Sidney, and eastern Montana. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Miles City, MT",
  heroSubtitle: "Eastern Montana ranch family trip to Canada? Oil and gas industry travel to Calgary? Bucking Horse Sale visitors heading abroad? We help Miles City residents — from Custer County ranching families to energy industry professionals to MCC students — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Miles%20City%20Montana%20historic%20downtown%20with%20the%20Yellowstone%20River%20flowing%20through%20golden%20prairie%20landscape%20at%20sunset%2C%20classic%20western%20brick%20buildings%20on%20main%20street%2C%20cottonwood%20trees%20along%20the%20riverbank%2C%20vast%20Montana%20big%20sky%20with%20dramatic%20cloud%20formations%2C%20warm%20amber%20and%20gold%20tones%2C%20editorial%20travel%20photography%20style%20with%20authenticity%20and%20natural%20beauty%2C%20no%20people%20visible&width=1800&height=700&seq=miles-city-hero-2026&orientation=landscape",
  heroImageAlt: "Miles City Montana historic downtown along Yellowstone River at golden sunset",
  geoPosition: "46.4076;-105.8417",
  geoPlacename: "Miles City, Montana",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — approximately 530 miles from Miles City; not practical for eastern Montana residents",
  },
  nearbyCitiesZips: [
    { name: "Miles City", zips: "59301" },
    { name: "Glendive", zips: "59330" },
    { name: "Sidney", zips: "59270" },
    { name: "Baker", zips: "59313" },
    { name: "Forsyth", zips: "59327" },
    { name: "Jordan", zips: "59337" },
    { name: "Circle", zips: "59215" },
    { name: "Terry", zips: "59349" },
  ],
  benefits: [
    { icon: "ri-building-2-line", title: "No Denver Trip Required", desc: "Denver Passport Agency is 530 miles from Miles City. Our registered courier service handles everything remotely — no 8+ hour drive through Wyoming and Colorado." },
    { icon: "ri-road-map-line", title: "Eastern Montana's Passport Solution", desc: "Serving the vast distances of eastern Montana — from Glendive to Sidney to Baker. When the nearest agency is in another state, our remote service is the practical answer." },
    { icon: "ri-oil-line", title: "Energy Industry Travel Support", desc: "Bakken and Powder River Basin energy professionals traveling to Canada for industry conferences, training, and corporate meetings rely on us for fast passport processing." },
    { icon: "ri-home-2-line", title: "Ranch & Agricultural Community", desc: "Eastern Montana ranching families traveling internationally for agricultural expos, heritage trips, and family visits — we understand the region and its unique passport needs." },
  ],
  internalLinks: [
    { name: "Expedited passport in Billings, MT", route: "/cities/billings" },
    { name: "Fast passport services in Bismarck, ND", route: "/cities/bismarck" },
    { name: "Quick passport services in Rapid City, SD", route: "/cities/rapid-city" },
    { name: "Urgent passport services in Bozeman, MT", route: "/cities/bozeman" },
    { name: "Montana passport services overview", route: "/states/montana" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Miles City via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 530 miles to Colorado. Miles City residents can ship from the UPS Store or post office right on Main Street.",
  fpcOfficeDistance: "Serving Miles City, Glendive, Sidney, Baker, Forsyth, and all eastern Montana communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Miles City and eastern Montana. From the historic downtown district along the Yellowstone River to the ranching communities of Custer County, from Glendive's Makoshika State Park area to the Bakken energy corridor near Sidney — we serve all of eastern Montana. Our courier service eliminates the need to drive 530 miles to Denver.",
  nearbyCitiesIntro: "We serve Miles City and all surrounding eastern Montana communities including Glendive, Sidney, Baker, Forsyth, Jordan, Circle, and Terry. We also serve MCC students, Custer County ranchers, and energy professionals throughout the region.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Miles City as simple as possible — with the reliability eastern Montana ranchers, energy professionals, and families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Miles City travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Miles City and eastern Montana travelers face unique passport challenges — from vast distances to limited local services to Canada border crossing patterns. Here are the most common mistakes we see.",
  testimonialsIntro: "Eastern Montana travelers — from Custer County ranch families to Miles City business owners to energy industry professionals — trust us when their international plans require a passport and Denver is 530 miles away.",
  faqIntro: "Have questions about expedited passports in Miles City, MT? Here are the most common ones we hear from eastern Montana travelers.",
  statePageRoute: "/states/montana",
  statePageName: "Montana",
  servicesIntro: "Whether you need a renewal before a trip to Canada for an agricultural expo, an emergency passport for a last-minute energy conference, or a first-time passport for a Custer County family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dojmt.gov/driving/",
  dmvLabel: "Montana Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 530 miles from Miles City", "Completely impractical for eastern Montana residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — entirely remote from Miles City", "Ideal for upcoming Canada travel or conferences", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service post office", "Good for planned agricultural expos or family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload shifts with government shutdowns", "In-person clerk appointment required in Miles City", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Agricultural expo in Regina next week? Energy conference in Calgary in 5 days? Our emergency courier service gets it done — as fast as 24 hours for Miles City travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Miles City residents renew fast without driving to Denver. Perfect for Custer County families, ranchers, and energy professionals heading abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Miles City residents through every step with clear instructions for the nearest Custer County acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional forms. We guide you through everything needed — so your Canada trip or industry conference attendance is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Miles City family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for eastern Montana residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for energy industry consultants and agricultural professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Miles City and eastern Montana travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Perfect for eastern Montana residents crossing into Saskatchewan and Alberta.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Miles City MT", description: "Urgent passport processing for Miles City Montana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Miles City MT", description: "Fast passport renewal for Miles City Montana residents with a previously-issued passport." },
    { name: "First-Time Passport Miles City MT", description: "New passport application services for Miles City Montana residents applying for their first passport." },
    { name: "Child Passport Miles City MT", description: "Minor passport services for Miles City Montana families with children under 16." },
    { name: "Name Change Passport Miles City MT", description: "Passport name correction after marriage, divorce, or legal name changes for Miles City residents." },
    { name: "Second Passport Miles City MT", description: "Second passport services for Miles City energy and agriculture professionals." },
  ],
  testimonials: [
    {
      name: "Dustin R.",
      location: "Miles City",
      rating: 5,
      text: "I had an agricultural equipment expo in Regina, Saskatchewan coming up and my passport was expired. Living in eastern Montana, driving to Denver is totally unrealistic. Fast Passport Center handled it all remotely — passport arrived in 4 days.",
      service: "Passport Renewal",
    },
    {
      name: "The Henderson Family",
      location: "Custer County",
      rating: 5,
      text: "Our family ranch has been here for generations. We planned a heritage trip to Scotland and needed passports for the whole family. They guided us through everything and made sure our applications were perfect before submission.",
      service: "New Passports — Family",
    },
    {
      name: "Carrie M.",
      location: "Miles City",
      rating: 5,
      text: "Energy industry conference in Calgary was announced 2 weeks out. I realized my passport had expired the year before. Fast Passport Center got me a renewal in 5 business days. Saved my attendance.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Bob W.",
      location: "Glendive",
      rating: 5,
      text: "Retired and wanted to visit my son stationed in Germany. Never had a passport before. They walked me through the first-time application at the Glendive post office and everything went perfectly. Got my passport in 10 days.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "miles-city-1",
      name: "Miles City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "106 N 7th St",
      city: "Miles City",
      state: "MT",
      zip: "59301",
      phone: "(406) 232-2590",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Miles City",
      website: "https://tools.usps.com/find-location.htm?location=1377196",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Custer County and eastern Montana. Passport photos available on-site. Appointment recommended — call at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "miles-city-2",
      name: "Custer County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "1010 Main St",
      city: "Miles City",
      state: "MT",
      zip: "59301",
      phone: "(406) 874-3343",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Miles City — Custer County Courthouse",
      website: "https://www.custercountymt.gov/",
      websiteLabel: "Custer County Website",
      notes: "County clerk passport acceptance at the courthouse. Appointment recommended. Photo services not available — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "miles-city-3",
      name: "Glendive Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "221 N Kendrick Ave",
      city: "Glendive",
      state: "MT",
      zip: "59330",
      phone: "(406) 365-3424",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Glendive, Dawson County — about 75 miles north of Miles City",
      website: "https://tools.usps.com/find-location.htm?location=1373516",
      websiteLabel: "USPS Location",
      notes: "Serves Glendive and Makoshika State Park area. Limited acceptance hours — call ahead to confirm availability and book appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "miles-city-4",
      name: "Sidney Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "103 W Main St",
      city: "Sidney",
      state: "MT",
      zip: "59270",
      phone: "(406) 482-1815",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Sidney, Richland County — about 120 miles north of Miles City",
      website: "https://tools.usps.com/find-location.htm?location=1387415",
      websiteLabel: "USPS Location",
      notes: "Serves Sidney and the Bakken energy corridor. Limited hours — call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "miles-city-5",
      name: "Baker Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16 W Montana Ave",
      city: "Baker",
      state: "MT",
      zip: "59313",
      phone: "(406) 778-2146",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (call to confirm passport services)",
      distance: "Baker, Fallon County — about 80 miles southeast of Miles City",
      website: "https://tools.usps.com/find-location.htm?location=1362620",
      websiteLabel: "USPS Location",
      notes: "Small post office serving southeastern Montana. Very limited passport acceptance hours — call first to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "miles-city-6",
      name: "Billings Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2602 1st Ave N",
      city: "Billings",
      state: "MT",
      zip: "59101",
      phone: "(406) 657-5768",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Billings — about 140 miles west of Miles City via I-94",
      website: "https://tools.usps.com/find-location.htm?location=1363576",
      websiteLabel: "USPS Location",
      notes: "Largest USPS facility in Montana with regular passport acceptance hours and photo services. About 2 hours drive from Miles City — useful when local facilities are fully booked.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 530 miles from Miles City", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 8+ hours each way from Miles City", fpc: "Most Miles City travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict documentation required", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay from rural Montana", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Miles City", agency: "530-mile drive one way — 8+ hours, $80+ in gas, and likely an overnight stay", fpc: "Entirely remote — forms online, ship from Miles City, passport arrives at your Custer County door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but add travel costs, missed work, hotel in Denver", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Eastern Montana Context", agency: "No eastern Montana-specific guidance — no Bakken, ranching, or rural expertise", fpc: "Full eastern Montana knowledge — energy industry, agricultural community, vast distances" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Canada Border Crossings Don't Need a Passport",
      description: "Many eastern Montana residents cross into Saskatchewan and Alberta regularly. A driver's license no longer works for adult U.S. citizens — you need a passport, passport card, or enhanced ID. We help Miles City families get proper documentation before their next border crossing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Vast Distances to Services",
      description: "Eastern Montana is one of the most sparsely populated regions in the lower 48. From Baker to Sidney (about 200 miles), there are very few passport acceptance facilities. We help residents find the nearest facility with available appointments — often saving hours of unnecessary driving.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long Before Agricultural Expos or Rodeos",
      description: "Miles City's Bucking Horse Sale and regional agricultural expos send eastern Montana residents to Canada on predictable annual schedules. Many travelers wait until the month before — then discover standard processing won't make it. Our expedited service handles these predictable surges.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Rejections from Distant Pharmacy Shops",
      description: "Getting a compliant passport photo in rural Montana means a trip to the nearest pharmacy or post office — sometimes 50+ miles away. If that photo is rejected, the entire process resets. We review photos before you submit to catch issues the first time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using Old Forms Downloaded from Unofficial Sites",
      description: "We see eastern Montana applicants using outdated DS-11 or DS-82 forms found online. State Department forms are updated regularly. We provide current forms and review all documentation before submission to prevent rejection.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from your Miles City home or ranch office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you are a Custer County rancher heading to an agricultural expo or a family planning a heritage trip." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping from the Miles City post office or UPS location. No Denver trip needed — just drop off and we handle the rest." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so eastern Montana travelers never need to drive 530 miles to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Miles City, Glendive, or Baker address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Miles City, Montana?", a: "We offer Miles City-area clients expedited processing as fast as 24 hours. Standard expedited through our courier channel takes 5–10 business days. Because the nearest regional passport agency is in Denver (530 miles), our remote courier service is the most practical fast option in eastern Montana." },
    { q: "Do I need a passport to cross into Canada from eastern Montana?", a: "Yes. U.S. citizens need a passport, passport card, or enhanced driver's license for land crossings into Saskatchewan and Alberta. A standard Montana driver's license is no longer sufficient. Many Miles City and Glendive residents use passport cards for regular Canada border crossings." },
    { q: "Where can I get a passport acceptance near Miles City?", a: "Miles City has acceptance at the Main Post Office on 7th Street and the Custer County Clerk & Recorder at the courthouse. Additional facilities are in Glendive, Sidney, Baker, and Billings. We maintain a complete list with hours and appointment requirements for all eastern Montana facilities." },
    { q: "How far is the nearest passport agency from Miles City?", a: "The Denver Passport Agency is approximately 530 miles from Miles City — about an 8-hour drive via I-94 to Billings and then south on I-25. For eastern Montana residents, this drive is simply impractical. Our courier service processes your passport remotely, delivered to your Miles City door." },
    { q: "What is the best price for expedited passport service in Miles City?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping to and from our processing center, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. Best price guarantee included." },
    { q: "What documents do Miles City applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide an eastern Montana-specific checklist." },
    { q: "Can I get a passport photo in Miles City?", a: "Yes. Miles City Main Post Office offers on-site passport photos. Walgreens in Miles City also provides passport photo services. For Glendive and Sidney residents, local post offices and pharmacies typically offer photos — call ahead to confirm availability in smaller communities." },
    { q: "Can you help ranchers and agricultural professionals with Canada travel?", a: "Yes. Eastern Montana's agricultural community frequently travels to Canada for livestock auctions, equipment expos, and industry conferences in Regina, Saskatoon, Calgary, and Edmonton. We help ranchers and ag professionals get passports or passport cards fast when travel dates approach." },
    { q: "What if I need passports for my entire ranching family?", a: "We regularly handle family passport applications for eastern Montana ranch families. Each family member needs their own passport — including children. We provide clear checklists for each family member, coordinate acceptance facility visits, and ensure all applications are correct before submission." },
    { q: "How does the Bakken energy industry affect passport demand in eastern Montana?", a: "The Bakken and Powder River Basin energy industries create international travel demand for training at Canadian facilities, corporate meetings in Calgary, and global energy conferences. These trips often surface with 2–3 weeks notice — our expedited service handles these short timelines reliably." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Miles City Residents",
    intro: "Miles City's location in eastern Montana — far from international airports, close to Canada, and in one of the most sparsely populated regions in America — creates unique passport challenges. Here's what eastern Montana travelers need to know.",
    cards: [
      {
        icon: "ri-road-map-line",
        title: "Canada Border Crossings — Saskatchewan & Alberta",
        subtitle: "Regular cross-border travel for agriculture, energy, and family",
        description: "Miles City is roughly 2 hours from the North Dakota/Montana-Canada border. Eastern Montana residents regularly cross into Saskatchewan and Alberta for agricultural expos, livestock auctions, energy industry meetings, rodeos, and family visits. The proximity to Canada makes passport cards especially popular in this region — cheaper than full passport books and valid for land crossings.",
        tip: "For regular Canada crossers, a passport card ($30 government fee) is more practical than a full passport book ($130 fee). The card fits in your wallet and works at all land border crossings. We expedite passport cards with the same courier service.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "BIL — Billings Logan International Airport",
        subtitle: "Nearest major airport, 140 miles west of Miles City",
        description: "Billings Logan International Airport (BIL) is the nearest major airport for Miles City residents — about 2 hours drive west on I-94. BIL connects to Denver, Salt Lake City, Minneapolis, Seattle, Dallas, and Phoenix, serving as the eastern Montana gateway to international connections. For most Miles City residents, any international trip starts with a 2-hour drive to Billings.",
        tip: "Factor the 2-hour drive to BIL into your travel day. A 9 AM connection from Billings to Denver or Minneapolis means leaving Miles City by 6:30 AM. Have your passport ready and verified at least a week before your BIL departure.",
      },
      {
        icon: "ri-oil-line",
        title: "Energy Industry Travel — Bakken & Powder River Basin",
        subtitle: "Oil and gas professionals with international training and conference needs",
        description: "The Bakken formation stretches from North Dakota into eastern Montana, and the Powder River Basin includes significant energy operations near Miles City. Energy professionals in this region travel to Calgary, Edmonton, and international energy conferences — often with short notice when training sessions, corporate meetings, or conference slots become available.",
        tip: "Energy industry professionals who may travel to Canada should keep a valid passport at all times. Training sessions and corporate meetings in Calgary or Edmonton often get scheduled with 2–3 weeks notice — too tight for standard passport processing but manageable with our expedited service.",
      },
      {
        icon: "ri-home-2-line",
        title: "Ranch Country & Agricultural Travel",
        subtitle: "Livestock expos, equipment shows, and heritage travel",
        description: "Miles City is the cultural and economic center of eastern Montana ranching country. The annual Bucking Horse Sale draws visitors and participants from across the region. Ranchers attend livestock expos and equipment shows in Regina, Calgary, and Edmonton. Heritage travel to ancestral homelands in Ireland, Scotland, Germany, and Scandinavia is common among multi-generation ranching families.",
        tip: "Agricultural expos and livestock events in Canada have fixed dates — book your passport processing when you book your event registration, not when you pack your bags.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Eastern Montana's Distance Challenge — And Our Solution",
      description: "Miles City is 140 miles from the nearest major airport (BIL), 530 miles from the nearest passport agency (Denver), and surrounded by hundreds of miles of ranchland in every direction. Our remote courier service transforms this challenge — processing your passport from anywhere in Custer County and delivering it to your door, so you only have to drive to Billings for your flight, not to Denver for your documents.",
    },
  },
  destinations: {
    title: "Where Miles City Travelers Go — And Why Passports Get Urgent",
    intro: "Miles City's location in eastern Montana — close to Canada, far from international airports — creates distinct travel patterns. Here's what we see most frequently.",
    stats: [
      { stat: "50%", label: "of Miles City expedited requests involve Canada — land crossings or flights via Calgary/Regina" },
      { stat: "3–4 Weeks", label: "typical lead time from booking to departure for eastern Montana travelers" },
      { stat: "530 Miles", label: "distance to Denver Passport Agency — our courier service bridges this completely" },
      { stat: "4 Days", label: "shortest turnaround for a Miles City rancher heading to an agricultural expo in Regina" },
    ],
    destinations: [
      { name: "Canada", context: "Regina and Saskatoon agricultural expos, Calgary Stampede and energy conferences, Edmonton livestock shows, family visits in Saskatchewan/Alberta", urgency: "Agricultural events with fixed annual dates, energy conferences with 2–3 weeks notice", icon: "ri-map-pin-2-line" },
      { name: "Mexico", context: "Resort vacations in Cancun, Cabo, Puerto Vallarta through BIL connections, winter escape travel, agricultural equipment sourcing", urgency: "Winter vacation bookings made October–December", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Heritage travel to Ireland, Scotland, Germany, Scandinavia among ranching families; agricultural machinery expos in Germany and Italy", urgency: "Heritage trips planned 6–12 months ahead, but passports often checked last-minute", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Agricultural equipment and cattle genetics travel to Brazil and Argentina, beef industry conferences", urgency: "Industry events with fixed dates requiring 4–6 weeks planning", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Agricultural exchange programs, cattle and sheep industry conferences, ranch management training", urgency: "Exchange programs with 4–8 weeks notice from acceptance to departure", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Cruises", context: "Cruise departures from Seattle, Vancouver, and Galveston requiring BIL connections; winter vacation packages", urgency: "Cruise deals booked 3–4 weeks before departure", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Montana Service Areas",
    crossLinksDesc: "We serve travelers across Big Sky Country with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Billings", route: "/cities/billings" },
      { name: "Bismarck, ND", route: "/cities/bismarck" },
      { name: "Rapid City, SD", route: "/cities/rapid-city" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Miles City", address: "610 Main St, Miles City, MT 59301", hours: "Call for hours" },
    { name: "Miles City Main Post Office", address: "106 N 7th St, Miles City, MT 59301", hours: "Mon–Fri 9 AM – 4 PM (passport photos available)" },
    { name: "Walmart Supercenter — Billings", address: "2525 King Ave W, Billings, MT 59102", hours: "Daily 7 AM – 11 PM (about 140 miles from Miles City)" },
    { name: "Walgreens — Billings", address: "1212 Grand Ave, Billings, MT 59102", hours: "Call for hours" },
    { name: "CVS Pharmacy — Billings", address: "711 Grand Ave, Billings, MT 59101", hours: "Daily 8 AM – 9 PM" },
    { name: "Glendive Post Office", address: "221 N Kendrick Ave, Glendive, MT 59330", hours: "Mon–Fri 9 AM – 3:30 PM (passport photos may be available — call first)" },
    { name: "Sidney Post Office", address: "103 W Main St, Sidney, MT 59270", hours: "Mon–Fri 9 AM – 3:30 PM (call for photo availability)" },
  ],
  dmvLocations: [
    {
      name: "Custer County Treasurer — Motor Vehicle Division",
      address: "1010 Main St, Miles City, MT 59301",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Located in the Custer County Courthouse.",
      featured: true,
    },
    {
      name: "Montana MVD — Miles City Driver Exam Station",
      address: "12 N 10th St, Miles City, MT 59301",
      hours: "By appointment — call for availability",
      note: "Driver license testing and renewals. Appointment required. Call ahead for availability in eastern Montana.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BIL",
      name: "Billings Logan International Airport",
      distance: "About 140 miles west of Miles City (2 hours via I-94)",
      address: "1901 Terminal Cir, Billings, MT 59105",
      note: "Nearest major airport serving eastern Montana with connections to Denver, Salt Lake City, Minneapolis, Seattle, Dallas, Phoenix, and more. Primary international connection hub for Miles City residents.",
      flightUrl: "https://www.flybillings.com/",
      flightLabel: "Billings Airport Website",
      featured: true,
    },
    {
      code: "RAP",
      name: "Rapid City Regional Airport",
      distance: "About 250 miles southeast of Miles City (4 hours via I-94/US-212)",
      address: "4550 Terminal Rd, Rapid City, SD 57703",
      note: "Alternative airport with connections to Denver, Minneapolis, Dallas, Chicago, and Phoenix. Some Miles City residents prefer RAP for certain routes or airline preferences.",
      flightUrl: "https://www.rapairport.com/",
      flightLabel: "Rapid City Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Montana birth certificates from the Montana DPHHS Vital Records. Online, mail, or in-person at the Custer County Courthouse.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Montana DPHHS Vital Records. Required for estate and legal matters in Custer County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Custer County Clerk & Recorder. Certified copies available at the Miles City courthouse.",
      url: "https://www.custercountymt.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Custer County District Court. Required for name change passport corrections.",
      url: "https://www.custercountymt.gov/",
    },
  ],
};